// Toast.js
import React from 'react';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast = () => {
  return (
    <>
      <ToastContainer 
        position="bottom-left"
        transition={Slide}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        className="custom-toast"
        toastClassName="custom-toast-content"
        />
    </>
  );
};

// Function to show an error toast
export const showErrorToast = (message) => {
  toast.error(message, {
    position: "bottom-left",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

// Function to show a success toast
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "bottom-left",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

// Function to show a process (loading) toast
export const showProcessToast = (loadingMessage) => {
    // Show loading message and return the toast ID
    const toastId = toast.loading(loadingMessage, {
      position: "bottom-left",
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
    });
  
    return toastId; // Return the toast ID for future updates
  };

  export const updateToastMessage = (toastId, message, type) => {
    // Update the toast message with success or error and ensure it auto-closes
    const toastConfig = {
      render: message,
      type: type === 'success' ? 'success' : 'error',
      autoClose: 2000, // Ensures the toast auto-closes after 5 seconds
      isLoading: false,
      closeOnClick: true,
    };
  
    toast.update(toastId, toastConfig);
  };